/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type {
  Auth0UserDTO,
  Auth0UsersOut,
  CreateAuth0UserIn,
  CreateMembershipIn,
  CreateOrganisationIn,
  CreateUserIn,
  DeleteMembershipParams,
  GetTokenSpendParams,
  HTTPValidationError,
  ManagedUserDTO,
  ManagedUsersOut,
  OrganisationDTO,
  OrganisationsOut,
  TokenSpendOut,
  UpdateMembershipIn,
  UpdateOrganisationIn,
  UserSyncResultOut,
} from '../fastAPI.schemas'

/**
 * Create an Auth0 account. The user sets their password via the
"Passwort vergessen" flow on the login page.
 * @summary Create Auth0 User
 */
export const createAuth0User = (createAuth0UserIn: CreateAuth0UserIn, signal?: AbortSignal) => {
  return customInstance<Auth0UserDTO>({
    url: `/user-management/auth0-users`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createAuth0UserIn,
    signal,
  })
}

export const useCreateAuth0UserMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAuth0User>>,
    TError,
    { data: CreateAuth0UserIn },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAuth0User>>,
  TError,
  { data: CreateAuth0UserIn },
  TContext
> => {
  const mutationKey = ['createAuth0User']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAuth0User>>,
    { data: CreateAuth0UserIn }
  > = props => {
    const { data } = props ?? {}

    return createAuth0User(data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/user-management/auth0-users` },
    {
      operationId: 'create_auth0_user_user_management_auth0_users_post',
      operationName: 'createAuth0User',
    },
  )

  return customOptions
}

export type CreateAuth0UserMutationResult = NonNullable<Awaited<ReturnType<typeof createAuth0User>>>
export type CreateAuth0UserMutationBody = CreateAuth0UserIn
export type CreateAuth0UserMutationError = HTTPValidationError

/**
 * @summary Create Auth0 User
 */
export const useCreateAuth0User = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAuth0User>>,
    TError,
    { data: CreateAuth0UserIn },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof createAuth0User>>,
  TError,
  { data: CreateAuth0UserIn },
  TContext
> => {
  const mutationOptions = useCreateAuth0UserMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Auth0 accounts that have no mirrored ``users`` row yet.
 * @summary Get Unassigned Auth0 Users
 */
export const getUnassignedAuth0Users = (signal?: AbortSignal) => {
  return customInstance<Auth0UsersOut>({
    url: `/user-management/auth0-users/unassigned`,
    method: 'GET',
    signal,
  })
}

export const getGetUnassignedAuth0UsersQueryKey = () => {
  return [`/user-management/auth0-users/unassigned`] as const
}

export const getGetUnassignedAuth0UsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getUnassignedAuth0Users>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getUnassignedAuth0Users>>, TError, TData>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetUnassignedAuth0UsersQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnassignedAuth0Users>>> = ({
    signal,
  }) => getUnassignedAuth0Users(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUnassignedAuth0Users>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetUnassignedAuth0UsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUnassignedAuth0Users>>
>
export type GetUnassignedAuth0UsersQueryError = unknown

/**
 * @summary Get Unassigned Auth0 Users
 */

export function useGetUnassignedAuth0Users<
  TData = Awaited<ReturnType<typeof getUnassignedAuth0Users>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getUnassignedAuth0Users>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUnassignedAuth0UsersQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * End a membership. The user keeps their other organisations.
 * @summary Delete Membership
 */
export const deleteMembership = (params: DeleteMembershipParams) => {
  return customInstance<ManagedUserDTO>({
    url: `/user-management/memberships`,
    method: 'DELETE',
    params,
  })
}

export const useDeleteMembershipMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMembership>>,
    TError,
    { params: DeleteMembershipParams },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMembership>>,
  TError,
  { params: DeleteMembershipParams },
  TContext
> => {
  const mutationKey = ['deleteMembership']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMembership>>,
    { params: DeleteMembershipParams }
  > = props => {
    const { params } = props ?? {}

    return deleteMembership(params)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/user-management/memberships` },
    {
      operationId: 'delete_membership_user_management_memberships_delete',
      operationName: 'deleteMembership',
    },
  )

  return customOptions
}

export type DeleteMembershipMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMembership>>
>

export type DeleteMembershipMutationError = HTTPValidationError

/**
 * @summary Delete Membership
 */
export const useDeleteMembership = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMembership>>,
    TError,
    { params: DeleteMembershipParams },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMembership>>,
  TError,
  { params: DeleteMembershipParams },
  TContext
> => {
  const mutationOptions = useDeleteMembershipMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Add an already-provisioned user to a further organisation.
 * @summary Create Membership
 */
export const createMembership = (createMembershipIn: CreateMembershipIn, signal?: AbortSignal) => {
  return customInstance<ManagedUserDTO>({
    url: `/user-management/memberships`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createMembershipIn,
    signal,
  })
}

export const useCreateMembershipMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMembership>>,
    TError,
    { data: CreateMembershipIn },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMembership>>,
  TError,
  { data: CreateMembershipIn },
  TContext
> => {
  const mutationKey = ['createMembership']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMembership>>,
    { data: CreateMembershipIn }
  > = props => {
    const { data } = props ?? {}

    return createMembership(data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/user-management/memberships` },
    {
      operationId: 'create_membership_user_management_memberships_post',
      operationName: 'createMembership',
    },
  )

  return customOptions
}

export type CreateMembershipMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMembership>>
>
export type CreateMembershipMutationBody = CreateMembershipIn
export type CreateMembershipMutationError = HTTPValidationError

/**
 * @summary Create Membership
 */
export const useCreateMembership = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMembership>>,
    TError,
    { data: CreateMembershipIn },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof createMembership>>,
  TError,
  { data: CreateMembershipIn },
  TContext
> => {
  const mutationOptions = useCreateMembershipMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Grant or revoke the admin role and Planungsverantwortung for one membership.
 * @summary Update Membership
 */
export const updateMembership = (updateMembershipIn: UpdateMembershipIn) => {
  return customInstance<ManagedUserDTO>({
    url: `/user-management/memberships`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateMembershipIn,
  })
}

export const useUpdateMembershipMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMembership>>,
    TError,
    { data: UpdateMembershipIn },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMembership>>,
  TError,
  { data: UpdateMembershipIn },
  TContext
> => {
  const mutationKey = ['updateMembership']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMembership>>,
    { data: UpdateMembershipIn }
  > = props => {
    const { data } = props ?? {}

    return updateMembership(data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/user-management/memberships` },
    {
      operationId: 'update_membership_user_management_memberships_put',
      operationName: 'updateMembership',
    },
  )

  return customOptions
}

export type UpdateMembershipMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMembership>>
>
export type UpdateMembershipMutationBody = UpdateMembershipIn
export type UpdateMembershipMutationError = HTTPValidationError

/**
 * @summary Update Membership
 */
export const useUpdateMembership = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMembership>>,
    TError,
    { data: UpdateMembershipIn },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMembership>>,
  TError,
  { data: UpdateMembershipIn },
  TContext
> => {
  const mutationOptions = useUpdateMembershipMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Get Organisations
 */
export const getOrganisations = (signal?: AbortSignal) => {
  return customInstance<OrganisationsOut>({
    url: `/user-management/organisations`,
    method: 'GET',
    signal,
  })
}

export const getGetOrganisationsQueryKey = () => {
  return [`/user-management/organisations`] as const
}

export const getGetOrganisationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganisations>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getOrganisations>>, TError, TData>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOrganisationsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganisations>>> = ({ signal }) =>
    getOrganisations(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganisations>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetOrganisationsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganisations>>>
export type GetOrganisationsQueryError = unknown

/**
 * @summary Get Organisations
 */

export function useGetOrganisations<
  TData = Awaited<ReturnType<typeof getOrganisations>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getOrganisations>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrganisationsQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Create an empty organisation for users to be assigned to.
 * @summary Create Organisation
 */
export const createOrganisation = (
  createOrganisationIn: CreateOrganisationIn,
  signal?: AbortSignal,
) => {
  return customInstance<OrganisationDTO>({
    url: `/user-management/organisations`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createOrganisationIn,
    signal,
  })
}

export const useCreateOrganisationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrganisation>>,
    TError,
    { data: CreateOrganisationIn },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrganisation>>,
  TError,
  { data: CreateOrganisationIn },
  TContext
> => {
  const mutationKey = ['createOrganisation']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrganisation>>,
    { data: CreateOrganisationIn }
  > = props => {
    const { data } = props ?? {}

    return createOrganisation(data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/user-management/organisations` },
    {
      operationId: 'create_organisation_user_management_organisations_post',
      operationName: 'createOrganisation',
    },
  )

  return customOptions
}

export type CreateOrganisationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrganisation>>
>
export type CreateOrganisationMutationBody = CreateOrganisationIn
export type CreateOrganisationMutationError = HTTPValidationError

/**
 * @summary Create Organisation
 */
export const useCreateOrganisation = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrganisation>>,
    TError,
    { data: CreateOrganisationIn },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof createOrganisation>>,
  TError,
  { data: CreateOrganisationIn },
  TContext
> => {
  const mutationOptions = useCreateOrganisationMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Rename an organisation and/or update its postal address.
 * @summary Update Organisation
 */
export const updateOrganisation = (
  organisationGuid: string,
  updateOrganisationIn: UpdateOrganisationIn,
) => {
  return customInstance<OrganisationDTO>({
    url: `/user-management/organisations/${organisationGuid}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateOrganisationIn,
  })
}

export const useUpdateOrganisationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganisation>>,
    TError,
    { organisationGuid: string; data: UpdateOrganisationIn },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrganisation>>,
  TError,
  { organisationGuid: string; data: UpdateOrganisationIn },
  TContext
> => {
  const mutationKey = ['updateOrganisation']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrganisation>>,
    { organisationGuid: string; data: UpdateOrganisationIn }
  > = props => {
    const { organisationGuid, data } = props ?? {}

    return updateOrganisation(organisationGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/user-management/organisations/{organisationGuid}` },
    {
      operationId: 'update_organisation_user_management_organisations__organisation_guid__put',
      operationName: 'updateOrganisation',
    },
  )

  return customOptions
}

export type UpdateOrganisationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrganisation>>
>
export type UpdateOrganisationMutationBody = UpdateOrganisationIn
export type UpdateOrganisationMutationError = HTTPValidationError

/**
 * @summary Update Organisation
 */
export const useUpdateOrganisation = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganisation>>,
    TError,
    { organisationGuid: string; data: UpdateOrganisationIn },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof updateOrganisation>>,
  TError,
  { organisationGuid: string; data: UpdateOrganisationIn },
  TContext
> => {
  const mutationOptions = useUpdateOrganisationMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * AI chat tokens and cost per user for the turns started at or after
``since`` (all time when omitted).
 * @summary Get Token Spend
 */
export const getTokenSpend = (params?: GetTokenSpendParams, signal?: AbortSignal) => {
  return customInstance<TokenSpendOut>({
    url: `/user-management/token-spend`,
    method: 'GET',
    params,
    signal,
  })
}

export const getGetTokenSpendQueryKey = (params?: GetTokenSpendParams) => {
  return [`/user-management/token-spend`, ...(params ? [params] : [])] as const
}

export const getGetTokenSpendQueryOptions = <
  TData = Awaited<ReturnType<typeof getTokenSpend>>,
  TError = HTTPValidationError,
>(
  params?: GetTokenSpendParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getTokenSpend>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetTokenSpendQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTokenSpend>>> = ({ signal }) =>
    getTokenSpend(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTokenSpend>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetTokenSpendQueryResult = NonNullable<Awaited<ReturnType<typeof getTokenSpend>>>
export type GetTokenSpendQueryError = HTTPValidationError

/**
 * @summary Get Token Spend
 */

export function useGetTokenSpend<
  TData = Awaited<ReturnType<typeof getTokenSpend>>,
  TError = HTTPValidationError,
>(
  params?: GetTokenSpendParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getTokenSpend>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTokenSpendQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Users
 */
export const getUsers = (signal?: AbortSignal) => {
  return customInstance<ManagedUsersOut>({ url: `/user-management/users`, method: 'GET', signal })
}

export const getGetUsersQueryKey = () => {
  return [`/user-management/users`] as const
}

export const getGetUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetUsersQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({ signal }) =>
    getUsers(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getUsers>>>
export type GetUsersQueryError = unknown

/**
 * @summary Get Users
 */

export function useGetUsers<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUsersQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Provision an Auth0 subject: mirror it locally and give it a membership.

The organisation is mandatory and has to exist already -- create it on the
organisations tab first. Nothing here mints one on the caller's behalf.
 * @summary Create User
 */
export const createUser = (createUserIn: CreateUserIn, signal?: AbortSignal) => {
  return customInstance<ManagedUserDTO>({
    url: `/user-management/users`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createUserIn,
    signal,
  })
}

export const useCreateUserMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUser>>,
    TError,
    { data: CreateUserIn },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUser>>,
  TError,
  { data: CreateUserIn },
  TContext
> => {
  const mutationKey = ['createUser']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUser>>,
    { data: CreateUserIn }
  > = props => {
    const { data } = props ?? {}

    return createUser(data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/user-management/users` },
    { operationId: 'create_user_user_management_users_post', operationName: 'createUser' },
  )

  return customOptions
}

export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
export type CreateUserMutationBody = CreateUserIn
export type CreateUserMutationError = HTTPValidationError

/**
 * @summary Create User
 */
export const useCreateUser = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUser>>,
    TError,
    { data: CreateUserIn },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof createUser>>,
  TError,
  { data: CreateUserIn },
  TContext
> => {
  const mutationOptions = useCreateUserMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Refresh every mirrored user's email and name from Auth0.

Rows backfilled by the migrations have empty profiles; this fills them in.
Deliberately never creates users -- see ``sync_users_from_auth0``.
 * @summary Sync Users
 */
export const syncUsers = (signal?: AbortSignal) => {
  return customInstance<UserSyncResultOut>({
    url: `/user-management/users/sync`,
    method: 'POST',
    signal,
  })
}

export const useSyncUsersMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof syncUsers>>, TError, void, TContext>
}): UseMutationOptions<Awaited<ReturnType<typeof syncUsers>>, TError, void, TContext> => {
  const mutationKey = ['syncUsers']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncUsers>>, void> = () => {
    return syncUsers()
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/user-management/users/sync` },
    { operationId: 'sync_users_user_management_users_sync_post', operationName: 'syncUsers' },
  )

  return customOptions
}

export type SyncUsersMutationResult = NonNullable<Awaited<ReturnType<typeof syncUsers>>>

export type SyncUsersMutationError = unknown

/**
 * @summary Sync Users
 */
export const useSyncUsers = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof syncUsers>>, TError, void, TContext>
}): UseMutationResult<Awaited<ReturnType<typeof syncUsers>>, TError, void, TContext> => {
  const mutationOptions = useSyncUsersMutationOptions(options)

  return useMutation(mutationOptions)
}
